import 'snippets/_containers/modal/modal'
import './_purchase-options-modal.scss'
import './subscriber-modal-options'

import { ajaxAddToCartCallWithFetch } from 'snippets/cart-js/ajax-add-cart'
import {
  getOGCustomer,
  getOGUpcomingOrders,
  addItemToNextBox,
} from 'snippets/common/ordergroove-api-helper'
import {
  createFromItem,
  getOGOrder,
  refreshOGAuth,
} from '../common/ordergroove-api-helper'

const purchaseOptionsModal = document.querySelector('.purchase-options-modal')

function showModalOptions(option) {
  const notSubscriberModalOptions = document.querySelector(
    '.not-subscriber-modal-options',
  )
  const subscriberModalOptions = document.querySelector(
    '.subscriber-modal-options',
  )
  if (!notSubscriberModalOptions || !subscriberModalOptions) return

  switch (option) {
    case 'no-subscriber':
      subscriberModalOptions.classList.add('hide')
      notSubscriberModalOptions.classList.remove('hide')
      break
    case 'subscriber':
      notSubscriberModalOptions.classList.add('hide')
      subscriberModalOptions.classList.remove('hide')
      break
    default:
      break
  }
}

async function addToCartByPurchaseType(purchaseType, { sellingPlanId } = {}) {
  const id = purchaseOptionsModal.getAttribute('data-product-variant-id')
  let formData = {}

  if (purchaseType === 'one-time') {
    formData = {
      items: [
        {
          id,
        },
      ],
    }
  } else if (purchaseType === 'subscription') {
    formData = {
      items: [
        {
          id,
          selling_plan: sellingPlanId,
        },
      ],
    }
  }

  await ajaxAddToCartCallWithFetch(formData)
  purchaseOptionsModal.classList.remove('modal--open')
}

function toggleSubscriptionSection(hideSubscriptionSection) {
  const subscriptionSections =
    purchaseOptionsModal.querySelectorAll('.subscription-box')
  subscriptionSections.forEach((subscriptionSection) => {
    if (hideSubscriptionSection === 'hide') {
      subscriptionSection.classList.add('hide')
    } else if (hideSubscriptionSection === 'show') {
      subscriptionSection.classList.remove('hide')
    }
  })
}

async function toggleInNextBoxMessage(nextOrder) {
  const ogNextOrder = await getOGOrder(nextOrder.public_id)
  const productsInNextOrder = ogNextOrder.results.reduce(
    (result, { product }) => {
      result[product] = true
      return result
    },
    {},
  )
  const productId = purchaseOptionsModal.getAttribute('data-product-variant-id')
  const userWithSubOptions = document.querySelector('.user-with-sub-options')
  const productInNextBoxMessage = document.querySelector(
    '.product-in-next-box-message',
  )
  const productInNextBoxMessageText = document.querySelector(
    '.product-in-next-box-message-text',
  )

  const userLocale = new Intl.NumberFormat().resolvedOptions().locale
  const nextOrderDate = new Date(nextOrder.place).toLocaleDateString(
    userLocale,
    { month: 'short', day: 'numeric' },
  )
  productInNextBoxMessageText.innerHTML = `Look out for this product in your next box scheduled for ${nextOrderDate}`

  if (productsInNextOrder[productId]) {
    userWithSubOptions.classList.add('hide')
    productInNextBoxMessage.classList.remove('hide')
    return 'shown'
  } else {
    userWithSubOptions.classList.remove('hide')
    productInNextBoxMessage.classList.add('hide')
    return 'hidden'
  }
}

if (purchaseOptionsModal) {
  await refreshOGAuth()
  const ogCustomer = await getOGCustomer(window.dsc.customerId)
  const ogUpcomingOrders = await getOGUpcomingOrders(window.dsc.customerId)
  const nextOrderButton = document.querySelector('#add-to-next-box-button')
  const nextOrderOneTimeButton = document.querySelector('#add-one-time-button')
  const isUserWithSubscription = ogCustomer && ogUpcomingOrders.count > 0
  let userModal = document.querySelector('.not-subscriber-modal-options')

  if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
    ogUpcomingOrders.results.sort((a, b) => {
      const aOrderTime = new Date(a.place).getTime()
      const bOrderTime = new Date(b.place).getTime()
      if (aOrderTime < bOrderTime) {
        return -1
      } else if (aOrderTime > bOrderTime) {
        return 1
      } else {
        return 0
      }
    })
  }

  // check if user has an active subscription and setup custom og impulse upsell button and find the earliest subscription box
  if (nextOrderOneTimeButton && nextOrderButton && isUserWithSubscription) {
    userModal = document.querySelector('.subscriber-modal-options')
    const nextOrder = ogUpcomingOrders.results[0]

    // set date on button
    const userLocale = new Intl.NumberFormat().resolvedOptions().locale
    const nextOrderDate = new Date(nextOrder.place).toLocaleDateString(
      userLocale,
      { month: 'short', day: 'numeric' },
    )
    nextOrderButton.innerHTML = `Add to Next Box on ${nextOrderDate}`
    nextOrderOneTimeButton.innerHTML = `Add to Next Box on ${nextOrderDate}`

    showModalOptions('subscriber')

    nextOrderOneTimeButton.addEventListener('click', async (e) => {
      const orderId = nextOrder.public_id
      const productId = purchaseOptionsModal.getAttribute(
        'data-product-variant-id',
      )
      const productPrice = purchaseOptionsModal.getAttribute(
        'data-product-variant-price',
      )
      await addItemToNextBox({
        order: orderId,
        product: productId,
      })
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'add_to_next_box',
        addedSubtotal: productPrice,
      })

      if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
        toggleInNextBoxMessage(ogUpcomingOrders.results[0])
      } else {
        purchaseOptionsModal.classList.remove('modal--open')
      }
    })

    const subscribeOptionsButton = document.querySelector(
      '.subscriber-frequency',
    )
    if (subscribeOptionsButton) {
      subscribeOptionsButton.addEventListener('click', async (e) => {
        const selectedFrequency = document.querySelector(
          'input[name="subscriber-frequency"]:checked',
        )
        const orderId = ogUpcomingOrders.results[0].public_id
        const productId = purchaseOptionsModal.getAttribute(
          'data-product-variant-id',
        )
        const productPrice = purchaseOptionsModal.getAttribute(
          'data-product-variant-price',
        )
        const sellingFrequency = selectedFrequency.getAttribute(
          'data-selling-plan-frequency',
        )
        const response = await addItemToNextBox({
          order: orderId,
          product: productId,
        })
        await createFromItem({
          item: response.public_id,
          every: sellingFrequency,
        })
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'add_to_next_box',
          addedSubtotal: productPrice,
        })

        if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
          toggleInNextBoxMessage(ogUpcomingOrders.results[0])
        } else {
          purchaseOptionsModal.classList.remove('modal--open')
        }
      })
    }
  } else {
    // user is a guest or doesn't have a subscription
    const subscribeOptionsButton = document.querySelector(
      '.not-subscriber-frequency',
    )
    if (subscribeOptionsButton) {
      subscribeOptionsButton.addEventListener('click', (e) => {
        const selectedFrequencyValue = document.querySelector(
          'input[name="not-subscriber-frequency"]:checked',
        ).value
        addToCartByPurchaseType('subscription', {
          sellingPlanId: selectedFrequencyValue,
        })
      })
    }
  }

  // open modal button
  const openPurchaseOptionsModalButtons = document.querySelectorAll(
    '.open-purchase-options-modal',
  )
  for (let i = 0; i < openPurchaseOptionsModalButtons.length; i++) {
    let openPurchaseOptionsModalButton = openPurchaseOptionsModalButtons[i]
    openPurchaseOptionsModalButton.addEventListener('click', async (e) => {
      e.preventDefault()

      // setup modal UI based on user settings
      purchaseOptionsModal.setAttribute(
        'data-product-variant-id',
        openPurchaseOptionsModalButton.getAttribute('data-product-variant-id'),
      )
      purchaseOptionsModal.setAttribute(
        'data-product-variant-price',
        openPurchaseOptionsModalButton.getAttribute(
          'data-product-variant-price',
        ),
      )
      const numberOfSellingPlans = openPurchaseOptionsModalButton.getAttribute(
        'data-product-number-of-selling-plans',
      )
      const hasSubscription = ogUpcomingOrders && ogUpcomingOrders.results.length
      if (numberOfSellingPlans === '0' && !hasSubscription) {
        // user doesn't have a sub and product is not subscriable - we just add to the cart and skip the modal
        addToCartByPurchaseType('one-time')
        return
      }

      // focus trap
      const previousFocusElement = document.activeElement
      const closeButtonElement =
        purchaseOptionsModal.querySelector('.button__icon')
      const focusableElements =
        '[tabindex]:not([tabindex="-1"]), [href], button, input, .button__icon'
      const modalFocusableElements =
        userModal.querySelectorAll(focusableElements)
      const firstFocusableElement =
        purchaseOptionsModal.querySelectorAll(focusableElements)[0]
      const oneTimePurchaseButton = modalFocusableElements[0]
      oneTimePurchaseButton.focus()
      const focusableContent = [closeButtonElement, ...modalFocusableElements]
      let lastFocusableElement = focusableContent[focusableContent.length - 1]

      function focusTrap(e) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9
        let isEscPressed = e.key === 'Escape' || e.keyCode === 27

        if (isEscPressed) {
          document.removeEventListener('keydown', focusTrap)
          previousFocusElement.focus()
        }

        if (!isTabPressed) {
          return
        }

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus()
            e.preventDefault()
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus()
            e.preventDefault()
          }
        }
      }

      $(window).on('close.modal', function () {
        document.removeEventListener('keydown', focusTrap)
        previousFocusElement.focus()
      })

      document.addEventListener('keydown', focusTrap)

      let isNextBoxMessageState = 'hidden'

      if (hasSubscription) {
        // user has a subscription
        isNextBoxMessageState = await toggleInNextBoxMessage(
          ogUpcomingOrders.results[0],
        )

        // setup modal to have subscription selected with correct modal options
        const subscribeRadioButton = document.querySelector('#subscribe')
        const oneTimeRadioButton = document.querySelector('#one-time')
        const subscribeOptions = document.querySelector('.subscribe-options')
        const oneTimeOptions = document.querySelector('.one-time-options')

        if (numberOfSellingPlans === '0') {
          // product is not subscribeable
          subscribeRadioButton.disabled = true
          subscribeRadioButton.checked = false
          subscribeOptions.classList.add('hide')
          oneTimeRadioButton.checked = true
          oneTimeOptions.classList.remove('hide')

          nextOrderButton.focus()
        } else if (isNextBoxMessageState === 'shown') {
          // product is in the next box
          toggleSubscriptionSection('hide')
        } else {
          // product is subscribeable and not in the next box
          toggleSubscriptionSection('show')
          subscribeRadioButton.checked = true
          subscribeRadioButton.disabled = false
          oneTimeRadioButton.checked = false
          subscribeOptions.classList.remove('hide')
          oneTimeOptions.classList.add('hide')
        }
      } else {
        // user does not have a sub
        toggleSubscriptionSection('show')
      }

      purchaseOptionsModal.classList.add('modal--open')
    })
  }

  const oneTimeButtons = document.querySelectorAll('.button__one-time')
  for (let j = 0; j < oneTimeButtons.length; j++) {
    oneTimeButtons[j].addEventListener('click', (e) => {
      e.preventDefault()
      addToCartByPurchaseType('one-time')
    })
  }
}
